// @ts-nocheck
import { httpClient } from '../../../core/network';

class SubscriptionService {
  static fetchSubscriptions(userId, expired = false, page = 1, size = 20) {
    const apiUrl = `/users/${userId}/subscriptions`;
    return httpClient.get(apiUrl, {
      params: { expired, page, size },
    });
  }

  static fetchSubscription(userId, subscriptionId) {
    const apiUrl = `/users/${userId}/subscriptions/${subscriptionId}`;
    return httpClient.get(apiUrl);
  }

  static closeSubscription(userId, subscriptionId, force = false) {
    const apiUrl = `/users/${userId}/subscriptions/${subscriptionId}`;
    return httpClient.delete(apiUrl, {
      params: { force },
    });
  }

  static invalidateCache(userId) {
    const apiUrl = `/subscribers/${userId}/invalidatecaches`;
    return httpClient.delete(apiUrl);
  }

  static checkIfUserCanBeAddedToContract(userId) {
    const apiUrl = `/subscribers/${userId}/allowed`;
    return httpClient.head(apiUrl);
  }

  static fetchDiscountReasons() {
    const apiUrl = '/options/discountreasons';
    return httpClient.get(apiUrl);
  }

  static addSubscriptionDiscount(userId, subscriptionId, discount) {
    const apiUrl = `/users/${userId}/subscriptions/${subscriptionId}/discount`;
    return httpClient.post(apiUrl, discount);
  }
}

export default SubscriptionService;
